(function($) {
    'use strict';


	/**
	* Initiate independent functions
	*/
	function fnInit() {
		$('form.data-capture').each(fnDataCaptureForm);
		$( 'header.primary' ).each( fnHeaderPrimary );						    // Header
		$( 'header.primary' ).each( fnNavigationPrimary );						// Header navigation
		$( 'body' ).on( 'click', 'a.hash-link', fnScrollToID );					// Smooth anchor links
		$( 'video.main-video' ).each( fnResponsiveVideoLoading );				// Makes videos load responsivley as alot of browsers don't support media queries for video loading
		$( '.lazy' ).each( fnLazyLoad );										// Lazyload images
		$( '.slick-slider' ).each( fnSlickSlider );								// Slider(s) (Slick)
		$( '.google-map' ).each(fnGoogleMap);									// Inits and runs the google map pins. Needs more work 9 task added in asana for adam)
		fnInViewDetect();														// Adds in view detection
		$('.lightbox').fancybox();												// Enables lightboxes
        $( '.dropkick select' ).dropkick({ mobile: true });                     // Select drop-down styling (Dropkick.js)
		fnConnectionSpeedClasses();												// Adds connection speed classes to the url
		fnShowBrowserVersion();													// Outputs the browser version into the console for testing
		fnPageLoaded();															// Runs when the page is loaded
		fnExternalLink();
		fnAccordion();															// FAQ Accordion
		fnCounter();

        /**
        * Google ReCAPTCHA (custom download forms)
        */
        // grecaptcha.ready(function() {
        //     grecaptcha.execute( '6Lf-0ZwUAAAAAEZtLcAsWzxOkjVjFzbq8GgGCwqO', {action: 'download_form'} ).then( function( token ) {
        //         var oRecapturaInput = $('input[name="g-recaptcha-response"]', 'form.data-capture' );
        //         if ( oRecapturaInput.length ) {
        //             $( 'input[name="g-recaptcha-response"]', 'form.data-capture' ).val( token );
        //         }
        //     });
        // });

	}
    fnInit();


}(jQuery));
